// Character Creation Rules
export const DEFAULT_BONDS = 3;
export const DEFAULT_MAX_BONDS = 4;
export const DEFAULT_MIN_BONDS = 1;
export const DEFAULT_SKILL_POINTS = 400;
export const BONDS_TO_POINTS_MULTIPLIER = 50;
export const DEFAULT_MAX_SKILL_VALUE = 60; 
export const DEFAULT_BONUS_VALUE = 20;
export const DEFAULT_TOTAL_CAP = 80;
export const DEFAULT_CAP_INCLUDING_DAMAGED_VETERAN_BONUS = 90;
export const MAX_BONUS_POINTS = 8;
export const MAX_PERSONAL_MOTIVATIONS = 5;
export const MAX_HARDENED_VETERAN_SKILLS = 5;
export const DV_BONUS = 10;